const FIELD_LABELS: Record<string, string> = {
  cpf: 'CPF',
  cnpj: 'CNPJ',
  profession: 'profissão',
  name: 'nome do ministrante',
  companyName: 'razão social',
  trainingDate: 'data do treinamento',
  workloadHours: 'carga horária',
  certificateType: 'tipo de certificado',
  title: 'título',
  plannedDate: 'data da programação',
  notes: 'observações',
  memberId: 'colaborador',
  positionId: 'cargo',
};

function friendlyFieldLabel(fieldPath: string): string {
  const leaf = fieldPath.split('.').pop() ?? fieldPath;
  return FIELD_LABELS[leaf] ?? leaf;
}

export function buildFieldErrorMessage(fieldErrors: Record<string, string[]>): string {
  const labels = Array.from(new Set(Object.keys(fieldErrors).map(friendlyFieldLabel)));

  if (labels.length === 1) {
    return `Verifique o campo de ${labels[0]}.`;
  }

  return `Verifique os campos: ${labels.join(', ')}.`;
}
